export function haversineMiles(a, b) {
  const R = 3958.8; const t = (x) => (x * Math.PI) / 180;
  const dLa = t(b.lat - a.lat); const dLo = t(b.lng - a.lng);
  const h = Math.sin(dLa / 2) ** 2 + Math.cos(t(a.lat)) * Math.cos(t(b.lat)) * Math.sin(dLo / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** Rough drive minutes when Google is unavailable: straight line x 1.3 at 32 mph, plus 2 minutes to park. */
export function estDriveMin(a, b) {
  return (haversineMiles(a, b) * 1.3 / 32) * 60 + 2;
}

export const hasXY = (p) => !!p && typeof p.lat === 'number' && typeof p.lng === 'number' && !Number.isNaN(p.lat);

/** Seconds from a protobuf duration string like '1234s' or '12.5s'. */
export function secs(d) {
  if (d == null) return 0;
  if (typeof d === 'number') return d;
  const m = String(d).match(/^(-?\d+(?:\.\d+)?)s$/);
  return m ? Number(m[1]) : 0;
}
